import { Box, Button, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { LiveContainer } from '../../LiveContainer';
import { useCoeolytics } from '@/js/shared/context/CoeolyticsHooks';
import EntityListView from '@/js/shared/components/dashboards/EntityListView';

const useStyles = makeStyles(() => ({
  description: {
    // whiteSpace: 'pre-wrap',
  },
}));

const Expo = (props) => {
  const classes = useStyles();
  const [isEmpty, setIsEmpty] = useState(false);
  const [expoList, setExpoList] = useState([]);
  const coeoLytics = useCoeolytics();

  useEffect(() => {
    if (props.history.action == 'PUSH') {
      coeoLytics.page();
    }
    axios
      .get(`/api/visitor/conferences/${window.CONFERENCE_ID}/entityexpo`)
      .then((response) => {
        if (response.data.length > 0) {
          setExpoList(response.data);
        } else {
          setIsEmpty(true);
        }
      });
  }, []);

  return (
    <LiveContainer
      isActive={(to) => {
        return to === `/live/expo`;
      }}
    >
      <Box>
        {isEmpty && (
          <Box align="center" p={3}>
            <Typography variant="subtitle1" gutterBottom>
              Nothing in the expo area
            </Typography>
          </Box>
        )}
        {expoList.map((entityList) => (
          <Box align="center" p={1} key={entityList.id}>
            <EntityListView entityListId={entityList.id} />
          </Box>
          // <Box align="center" p={1} key={entityList.id}>
          //   <Typography variant="h5" gutterBottom>
          //     {entityList.title}
          //   </Typography>
          //   <Box pb={1} className={classes.description}>
          //     <MarkdownRender text={entityList.description} />
          //   </Box>
          //   <EntityCards
          //     entityListId={entityList.id}
          //     entities={entityList.entities}
          //     history={props.history}
          //   />

          //   <Button style={{ display: 'none' }}>
          //     Trick, just to enable html inject
          //   </Button>
          // </Box>
        ))}
      </Box>
    </LiveContainer>
  );
};

export default Expo;
